
import React from 'react';
import { Navigate } from 'react-router-dom';

const PhotographerOrDirectorOrAdminRoute = ({ user, children }) => {
    if (!user || (user.role !== 'admin' && user.role !== 'director' && user.role !== 'photographer')) {
        return <Navigate to="/login" />;
    }

    return children;
};

export default PhotographerOrDirectorOrAdminRoute;
